import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../App.css';

function About() {
  const [activeSection, setActiveSection] = useState('about');

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <Header />

      {/* Main Content */}
      <main className="about-page-new">
        {/* Hero Section with Title and Navigation */}
        <section className="about-hero" id="about">
          <div className="about-hero-container">
            <nav className="about-sidebar">
              <ul>
                <li 
                  className={activeSection === 'about' ? 'active' : ''}
                  onClick={() => scrollToSection('about')}
                >
                  Бидний тухай.
                </li>
                <li 
                  className={activeSection === 'team' ? 'active' : ''}
                  onClick={() => scrollToSection('team')}
                >
                  Манай баг.
                </li>
                <li 
                  className={activeSection === 'mission' ? 'active' : ''}
                  onClick={() => scrollToSection('mission')}
                >
                  Эрхэм зорилго.
                </li>
              </ul>
            </nav>
            <div className="about-hero-content">
              <h1 className="about-hero-title">БИДНИЙ ТУХАЙ.</h1>
              <div className="about-hero-text">
                <p>
                  Тасралтгүй Боловсрол Судалгааны Институт нь Улаанбаатар хотод 2020 онд байгуулагдсан 
                  боловсролын байгууллага юм. Манай институт нь технологийн хурдацтай өөрчлөлтийн 
                  үед шаардлагатай мэдлэг, ур чадварыг олгох зорилготой ажилладаг.
                </p>
                <p>
                  21-р зуун бол тасралтгүй боловсрол эзэмшихээс өөр аргагүй эрин үе юм.
                  Технологийн хурдацтай өөрчлөлтийн үр дүнд зарим мэргэжил, ур чадвар орлогдож, шинэ мэдлэг,
                  ур чадвар шаардлагатай болж байна. Манай институт энэхүү 21-р зууны хэрэгцээ
                  шаардлагыг хангах, дэлхийн түвшний боловсрол олгохын зэрэгцээ ёс зүйтэй суралцагч,
                  төгсөгч, багш, хамт олны хотол (community) үүсгэхээр ажиллаж байна.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="about-mission-section" id="mission">
          <div className="about-mission-container">
            <h2 className="about-mission-title">ЭРХЭМ ЗОРИЛГО.</h2>
            <div className="about-mission-content">
              <p>
                Бид ажил олгогчтой олон талаар хамтарсан, хэрэгцээ шаардлагыг нь хангасан, уян хатан, 
                тасралтгүй шинэчлэгддэг, орчин үеийн технологи, прагматик хэрэглээнд тулгуурласан
                сургалтыг санал болгож хөдөлмөрийн бүтээмжийг нэмэгдүүлэх зорилготойгоор
                байгуулагдсан юм.
              </p>
              <ul className="about-mission-list">
                <li>Ажил олгогчтой олон талаар хамтарсан, хэрэгцээ шаардлагыг нь хангасан</li>
                <li>Уян хатан, тасралтгүй шинэчлэгддэг</li>
                <li>Орчин үеийн технологи, прагматик хэрэглээнд тулгуурласан</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Full Width Image */}
        <section className="about-full-image">
          <img 
            src="https://i0.wp.com/edu-icer.mn/wp-content/uploads/2025/05/DSC4500-1.jpg?resize=1280%2C576&ssl=1" 
            alt="ICER Institute Team"
          />
        </section>

        {/* Quote Section */}
        <section className="about-quote-section">
          <div className="about-quote-container">
            <div className="about-quote-content">
              <span className="quote-mark">"</span>
              <blockquote className="about-quote">
                <em>Хөдөлмөрийн бүтээмж бол тухайн үндэстний үйлдвэрлэлийн чадавхыг харуулдаг. Хэр боловсролтой байна вэ, хэр их капитал хуримтлагдсан бэ гэх мэт асуултын эцсийн хариулт хөдөлмөрийн бүтээмжээр илэрнэ.</em>
              </blockquote>
              <div className="quote-author">
                {/* <span className="author-name">С. Өнөр</span> */}
                <span className="author-title">ТАСРАЛТГҮЙ БОЛОВСРОЛ СУДАЛГААНЫ ИНСТИТУТЫН ДААЛГАВАР</span>
              </div>
            </div>
            <div className="about-quote-image">
              <img 
                src="https://i0.wp.com/edu-icer.mn/wp-content/uploads/2025/05/17a80-masd_img_001.jpg?resize=1024%2C840&ssl=1" 
                alt="Leadership"
              />
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="about-team-section" id="team">
          <div className="about-team-container">
            <div className="about-team-photos">
              <div className="team-photo team-photo-large">
                <img 
                  src="https://i0.wp.com/edu-icer.mn/wp-content/uploads/2025/05/e3a56-img_1292.jpg?resize=1080%2C733&ssl=1" 
                  alt="Team Member 1"
                />
              </div>
              <div className="team-photo team-photo-small">
                <img 
                  src="https://i0.wp.com/edu-icer.mn/wp-content/uploads/2025/05/17a80-masd_img_001.jpg?resize=1024%2C840&ssl=1" 
                  alt="Team Member 2"
                />
              </div>
            </div>
            <div className="about-team-content">
              <h2 className="about-team-title">МАНАЙ БАГ.</h2>
              <p className="about-team-desc">
                Хөдөлмөрийн бүтээмж бол тухайн үндэстний үйлдвэрлэлийн чадавхыг харуулдаг. Хэр
                боловсролтой байна вэ, хэр их капитал хуримтлагдсан бэ гэх мэт асуултын эцсийн
                хариулт хөдөлмөрийн бүтээмжээр илэрнэ.
              </p>
              <p className="about-team-desc">
                Чанартай боловсрол, ур чадвар бол хөдөлмөрийн бүтээмжийг нэмэгдүүлэх, цаашлаад
                бодит цалинг өсгөх, тэгш бус байдлыг бууруулах чухал хөшүүрэг юм.
              </p>
              
              {/* Stats */}
              <div className="about-stats">
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Төгсөгчид</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Багш нар</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">20+</span>
                  <span className="stat-label">Хөтөлбөрүүд</span>
                </div>
                <div className="stat-item stat-arrow">
                  <span className="stat-icon">↗</span>
                  <span className="stat-number">4+</span>
                  <span className="stat-label">Жилийн туршлага</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        

        {/* Visit Site CTA */}
        <section className="about-cta-section">
          <a href="/courses" className="about-cta-link">
            <span className="cta-arrow">↗</span> Хөтөлбөрүүд үзэх
          </a>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
